import { useEffect, useState } from 'react';
import { Alert, Input } from '@piggytechng/component-library';
import { AxiosResponse } from 'axios';
import { IoEyeSharp } from 'react-icons/io5';
import { FaEyeSlash } from 'react-icons/fa';
import { authPayload } from '../../helpers/utils/auth-payload';
import { httpClient } from '../../api/http';
import { localStorageEnum } from '../../api/enums';
import { OverideInputStyle } from '../../helpers/utils';
import ModalBase from '../Modals';
import '../Modals/index.scss';
import { AdminAuthCheckProps } from '../../types';

const AdminAuthCheck = ({
  action,
  onClose,
  text = 'execute this action',
  buttonText = 'Yes',
  actionColor = '#1734CA',
}: AdminAuthCheckProps) => {
  const [adminPassword, setAdminPassword] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    setAdminPassword('');
    setShowPassword(false);
  }, []);

  const closeModal = () => onClose();

  const executeAction = async (e?: { preventDefault: () => void }) => {
    if (e) e.preventDefault();
    try {
      if (adminPassword === '') {
        Alert.warn('Please type your password to proceed');
        return;
      }
      setIsLoading(true);
      const adminId = localStorage.getItem(localStorageEnum['local.storage.email']);
      if (!adminId) {
        Alert.error('Please logout and try again');
        onClose();
        return;
      }
      const payload = authPayload(adminPassword);
      const response: AxiosResponse = await httpClient.post('admin/auth-check', payload);

      if (response.data.status) {
        action();
        onClose();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalBase modalIsOpen={true} setIsOpen={(open: boolean) => !open && closeModal()}>
      <div className="modal-base general success action flex--4">
        <span onClick={closeModal}>&times;</span>
        <form onSubmit={executeAction}>
          <h4>Are you sure you want to {text}</h4>

          <div className="input-cont flex--2">
            <Input
              {...OverideInputStyle}
              label="Input Password "
              className="user-form-input"
              height="60px"
              placeholder="Password"
              type={showPassword ? 'text' : 'password'}
              onChange={(e: any) => {
                e.preventDefault();
                setAdminPassword(e.target.value);
              }}
              id="password"
              name="password"
              value={adminPassword}
            />
            {!showPassword ? (
              <div className="password-icon pointer" onClick={() => setShowPassword(true)}>
                <IoEyeSharp size={20} />
              </div>
            ) : (
              <div className="password-icon pointer" onClick={() => setShowPassword(false)}>
                <FaEyeSlash size={20} />
              </div>
            )}
          </div>

          <div className="button-cont flex--2">
            <button
              type="button"
              onClick={() => {
                closeModal();
              }}
            >
              Cancel
            </button>

            <button type="submit" style={{ backgroundColor: actionColor }}>
              {isLoading ? 'Loading...' : buttonText}
            </button>
          </div>
        </form>
      </div>
    </ModalBase>
  );
};

export default AdminAuthCheck;
